import React from "react";
import { Headset, ChatText, EnvelopeSimple, WhatsappLogo } from "@phosphor-icons/react";

export const CHANNELS = {
  calls: { label: "AI Telecalling", icon: Headset, color: "#8b5cf6", soft: "bg-violet-500/10 text-violet-500" },
  sms: { label: "SMS Marketing", icon: ChatText, color: "#0ea5e9", soft: "bg-sky-500/10 text-sky-500" },
  email: { label: "Email Outreach", icon: EnvelopeSimple, color: "#f59e0b", soft: "bg-amber-500/10 text-amber-500" },
  whatsapp: { label: "WhatsApp Marketing", icon: WhatsappLogo, color: "#22c55e", soft: "bg-emerald-500/10 text-emerald-500" },
  trailer: { label: "Trailer Email", icon: EnvelopeSimple, color: "#10b981", soft: "bg-emerald-500/10 text-emerald-500" },
};

const TONE = {
  queued: "bg-slate-100 text-slate-600", sent: "bg-sky-50 text-sky-700", delivered: "bg-emerald-50 text-emerald-700", opened: "bg-violet-50 text-violet-700",
  clicked: "bg-indigo-50 text-indigo-700", replied: "bg-amber-50 text-amber-700", failed: "bg-red-50 text-red-700", bounced: "bg-red-50 text-red-700",
};
export const STATUS_LABEL = { opened: "Seen", clicked: "Clicked", replied: "Replied" };

export function StatusPill({ s }) {
  return <span className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-semibold capitalize ${TONE[s] || TONE.queued}`}>{STATUS_LABEL[s] || s}</span>;
}

export function Kpi({ label, value, sub, accent = "#f59e0b", testid }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 transition-transform duration-200 hover:-translate-y-0.5" data-testid={testid}>
      <span className="absolute left-0 top-0 h-full w-1" style={{ background: accent }} />
      <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">{label}</p>
      <p className="mt-2 font-heading text-3xl font-extrabold tabular text-slate-900">{value}</p>
      {sub && <p className="mt-1 text-xs text-slate-500">{sub}</p>}
    </div>
  );
}

export function Funnel({ steps, color }) {
  const max = Math.max(...steps.map((s) => s.value), 1);
  return (
    <div className="space-y-2.5">
      {steps.map((s) => (
        <div key={s.label} data-testid={`funnel-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
          <div className="flex justify-between text-xs mb-1"><span className="font-semibold text-slate-600">{s.label}</span><span className="font-mono text-slate-900">{s.value.toLocaleString()}</span></div>
          <div className="h-2.5 rounded-full bg-slate-100 overflow-hidden"><div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${(s.value / max) * 100}%`, background: color }} /></div>
        </div>
      ))}
    </div>
  );
}

export function SubTabs({ tabs, value, onChange, prefix }) {
  return (
    <div className="flex flex-wrap gap-1.5 rounded-2xl border border-slate-200 bg-white p-1.5 mb-5 w-fit" data-testid={`${prefix}-subtabs`}>
      {tabs.map(([k, l, I]) => (
        <button key={k} onClick={() => onChange(k)} data-testid={`${prefix}-tab-${k}`}
          className={`h-9 px-3.5 rounded-xl text-sm font-semibold inline-flex items-center gap-1.5 transition-colors ${value === k ? "bg-slate-900 text-white" : "text-slate-500 hover:text-slate-900 hover:bg-slate-50"}`}>
          {I && <I size={15} weight={value === k ? "fill" : "regular"} />}{l}
        </button>
      ))}
    </div>
  );
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—");
